import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=2b325863&scoped=true"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"
import style0 from "./Module.vue?vue&type=style&index=0&id=2b325863&prod&lang=scss"
import style1 from "./Module.vue?vue&type=style&index=1&id=2b325863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b325863",
  null
  
)

export default component.exports